import React, { useEffect, useMemo, useState } from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import supabase from '../../supabase/supabase';
import { shuffleMarqueeNames } from '../../utils/marquee';

const CURATED_VETERINARY_MODELS = ['Laudo Piometra', 'Laudo Macho', 'Laudo Fêmea'];

const mixedNames = (templates) => {
  const publicNames = templates
    .map((template) => String(template?.name || '').trim())
    .filter(Boolean);
  return shuffleMarqueeNames([...CURATED_VETERINARY_MODELS, ...publicNames]);
};

const ScopeMarquee = () => {
  const reduceMotion = useReducedMotion();
  const [models, setModels] = useState(() => shuffleMarqueeNames(CURATED_VETERINARY_MODELS));

  useEffect(() => {
    let active = true;

    const loadModels = async () => {
      const { data, error } = await supabase
        .from('templates')
        .select('name')
        .eq('is_public', true)
        .eq('seo_status', 'approved')
        .eq('seo_sanitized', true);

      if (!active || error) return;
      setModels(mixedNames(data || []));
    };

    loadModels();
    return () => { active = false; };
  }, []);

  const repeated = useMemo(() => {
    const source = models.length ? models : CURATED_VETERINARY_MODELS;
    return [...source, ...source, ...source, ...source];
  }, [models]);

  return (
    <section className="border-y border-line bg-paper py-7 overflow-hidden" aria-label="Modelos médicos e veterinários disponíveis">
      <div className="max-w-7xl mx-auto px-4 mb-4 flex items-end justify-between gap-4">
        <p className="text-sm font-semibold text-ink">Modelos do catálogo público</p>
        <a href="/modelos-laudo" className="hidden sm:inline text-xs font-semibold text-navy hover:underline whitespace-nowrap">Ver todos os modelos</a>
      </div>
      <div className="overflow-hidden">
        <motion.div
          className="flex w-max items-center gap-10 px-4"
          animate={reduceMotion ? undefined : { x: ['0%', '-25%'] }}
          transition={reduceMotion ? undefined : { duration: Math.max(120, models.length * 4.5), repeat: Infinity, ease: 'linear' }}
        >
          {repeated.map((model, index) => (
            <span key={`${model}-${index}`} className="font-display text-xl md:text-2xl font-semibold text-navy whitespace-nowrap">
              {model}<span className="text-selo ml-10" aria-hidden="true">·</span>
            </span>
          ))}
        </motion.div>
      </div>
      <div className="max-w-7xl mx-auto px-4 mt-4 sm:hidden">
        <a href="/modelos-laudo" className="text-xs font-semibold text-navy hover:underline">Ver todos os modelos</a>
      </div>
    </section>
  );
};

export default ScopeMarquee;
